module.exports = "/packs/media/images/brands/ameriprise-0b186c1aa375575c60c2554dd40efc84.png";